import React from 'react'
import clsx from 'clsx'
import { CircularProgress, useTheme } from '@mui/material'

import { SearchNormal } from 'iconsax-react'

import useStyles from './styles'

type SearchProps = React.InputHTMLAttributes<HTMLInputElement> & {
  hideIcon?: boolean
  loading?: boolean
}

const Search: React.FC<SearchProps> = ({
  hideIcon,
  loading,
  className,
  ...props
}) => {
  const classes = useStyles({ hideIcon })
  const theme = useTheme()
  return (
    <div className={clsx(classes.root, className)}>
      <input className={classes.search} {...props} />

      {!hideIcon &&
        (loading ? (
          <CircularProgress className={clsx(classes.icon, classes.loading)} />
        ) : (
          <SearchNormal size={theme.size.sm} className={classes.icon} />
        ))}
    </div>
  )
}

export default Search
